module.exports = __webpack_public_path__ + "static/fun-time/games/page002_game1/audio//M_Work harder.mp3";